/* eslint-disable */
import * as util from '../../assets/common/util.js'
// import * as hqUtil from '../../assets/js/hq/hqUtil.js'
// import { stat } from "fs";

const state = {
  marketid: 0,
  openTime: 0,
  closeTime: 0,
  currentContractId: 0,

  kLineData: [],
  marketDetails: [],
  item: {},
  pricedetail: [],
  pricedetailID: '', // 标记当前展示的分笔数据商品id,配合pricedetail使用
  buyLst: [],
  sellLst: [],
  buyOrderLst: [],
  sellOrderLst: [],
  buyOne: [],
  sellOne: [],
  buyMaxAmount: 0,
  sellMaxAmount: 0,
  // 2021-12-21新增 筛选实时成交信息
  pricedetail_big: {},

  // 可展示的商品列表 (登录后生效)
  queryTradeAuthArr: [],
  tvReadyFlags: false, // tv刷新状态
  /**top点击 start */
  // 当点击top触发更新
  topCLickNum: 0,
  // 标注top点击的买卖方向和级别
  topClickInfo: {
    type: 'buy', // buy/sell
    l: 0 // top1:0
  },
  commodityStrategy:[],//商品信息
  /**top点击 end */
  BusinessDetail:[],//行情简报
  CommodityHighLow:{
    high: '0.00',
    low: '0.00'
  } // 商品涨跌停价
}

// getters
const getters = {
  commodityStrategyGetter: state => state.commodityStrategy ,
  topClickInfo: (state) => {
    return state.topClickInfo
  },
  topCLickNum: (state) => {
    return state.topCLickNum
  },
  tvReadyFlagsGetter: (state) => {
    return state.tvReadyFlags
  },
  item: (state) => {
    // const itemData = state.item
    var arr = Object.keys(state.item)
    if (arr.length !== 0 && state.marketDetails && state.marketDetails.length > 0) {
        for (let i = 0; i < state.marketDetails.length; i++) {
            const element = state.marketDetails[i]
                /* eslint-disable */
            if (element.symbolId == state.item.symbolId) {
                return element
            }
        }
        return state.item
    } else if (state.marketDetails && state.marketDetails.length > 0) {
        const obj = state.marketDetails[0]
        return obj
    } else {
      return {}
    }
  },
  buyLst(state) {
    const itemData = state.buyLst.slice()
    return itemData
  },
  sellLst(state) {
    const itemData = state.sellLst.slice()
    return itemData
  },
  buyOrderLst(state) {
    const itemData = state.buyOrderLst.slice()
    return itemData
  },
  sellOrderLst(state) {
    const itemData = state.sellOrderLst.slice()
    return itemData
  },
  buyMaxAmount: (state) => {
    return state.buyMaxAmount
  },
  sellMaxAmount: (state) => {
    return state.sellMaxAmount
  },

  pricedetail: (state) => {
    const pricedetailData = state.pricedetail
    return pricedetailData
  },
  pricedetail_big: (state) => { // 大单筛选
    const pricedetailData = state.pricedetail_big.currentDataArray
    return pricedetailData
  },
  marketDetails: (state) => {
    for (let i = 0; i < state.marketDetails.length; i++) {
      const str = state.marketDetails[i].quotechange
      const zf = str.substring(0, 1)
      if (zf == '-') {
        // quotechangeColor 现货订单用 quotechangeColor1 行情列表用
        state.marketDetails[i].quotechangeColor = '#41b37d'
        state.marketDetails[i].quotechangeColor1 = '#41b37d'
      } else {
        state.marketDetails[i].quotechangeColor = '#d94066'
        state.marketDetails[i].quotechangeColor1 = '#d94066'
      }
      if(str=='0.00%'){
        state.marketDetails[i].quotechangeColor = '#c7c7c7'
        state.marketDetails[i].quotechangeColor1 = '#666666'
      }

      // 最新价。最新价和昨结价对比，高于昨结价展示红色、等于昨结价展示白色、低于展示绿色。
      let close = state.marketDetails[i].close // 最新价
      let clearPrice = state.marketDetails[i].clearPrice // 昨结价
      // closeToClearColor 现货订单用 closeToClearColor1 行情列表用
      state.marketDetails[i].closeToClearColor = '#c7c7c7'
      state.marketDetails[i].closeToClearColor1 = '#666666'
      if (typeof(close)==='number' && typeof(clearPrice)==='number'){
        if (close > clearPrice) {
          state.marketDetails[i].closeToClearColor = '#d94066'
          state.marketDetails[i].closeToClearColor1 = '#d94066'
        }
        if (close < clearPrice) {
          state.marketDetails[i].closeToClearColor = '#41b37d'
          state.marketDetails[i].closeToClearColor1 = '#41b37d'
        }
      }

    }
    return state.marketDetails.slice()
  },

  sellOne(state) {
    const itemData = state.sellOne
    return itemData
  },
  buyOne(state) {
    const itemData = state.buyOne
    return itemData
  },
  // timeLine、KLine
  kLineDataGetter: (state) => {
    return state.kLineData
  },
  queryTradeAuthArrGetter(state) {
    return state.queryTradeAuthArr
  },
  BusinessDetailGetter: (state) => {
    return state.BusinessDetail
  },
  CommodityHighLowGetter: (state) => {
    return state.CommodityHighLow
  }
}

// actions
const actions = {
}

// mutations
const mutations = {
  setCommodityStrategy(state, data) {
    state.commodityStrategy = data
    if (state.marketDetails.length > 0 && data.length > 0) {
      for (const j in state.marketDetails) {
          for (const item of state.commodityStrategy) {
              let n = 0
              if (Number(state.marketDetails[j].symbolId) === Number(item.commodityId)) {
                // const minPriceChange = item.minPriceChange // 最小数量变动单位
                // const minAmountChange = item.minAmountChange // 价格价格变动单位
                // let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
                // let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
                let pricePoint = 0
                let amountPoint = 0
                if (String(item.minPriceChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minPriceChange).indexOf('.') + 1 // 获取小数点的位置
                    pricePoint = String(item.minPriceChange).length - dotNum // 获取小数点后的个数
                }
                if (String(item.minAmountChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minAmountChange).indexOf('.') + 1 // 获取小数点的位置
                    amountPoint = String(item.minAmountChange).length - dotNum // 获取小数点后的个数
                }
                if (pricePoint <= 0) {
                  pricePoint = 0
                }
                if (amountPoint <= 0) {
                  amountPoint = 0
                }
              state.marketDetails[j].numStr = new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$')
              state.marketDetails[j].coinDigitalNum = pricePoint
              state.marketDetails[j].quantityNum = amountPoint
              state.marketDetails[j].quantityStr = new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$')// 数量
              state.marketDetails[j].unitNumeral = item.unitNumeral
              state.marketDetails[j].minPriceChange = item.minPriceChange
              state.marketDetails[j].minAmountChange = item.minAmountChange
              } else {
                  n++
                  if (n === state.commodityStrategy.length) {
                      state.marketDetails[j].numStr =/^(\d+)\.(\d{0,2}).*$/
                      state.marketDetails[j].coinDigitalNum = 2
                      state.marketDetails[j].quantityNum = 2 // 数量
                      state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量
                      state.marketDetails[j].unitNumeral = 1
                      state.marketDetails[j].minPriceChange = 1
                      state.marketDetails[j].minAmountChange = 1
                  }
              }
          }
      
      }
  }
  },
  setCommodityHighLow(state, data) {
    state.CommodityHighLow = data
  },
  setBusinessDetail(state, data) {
    state.BusinessDetail = data
  },
  topCLickNum(state, data) {
    state.topCLickNum++
  },
  topClickInfo(state, data) {
    state.topClickInfo = data
  },
  setTvReadyFlags(state, data) {
    state.tvReadyFlags = data
  },
  item(state, data) {
    state.item = data
  },
  sellMaxAmount(state, data) {
    state.sellMaxAmount = data
  },
  buyMaxAmount(state, data) {
    state.buyMaxAmount = data
  },
  updateMarketDetails(state, data) {
    state.marketDetails = [...data]
    if (state.commodityStrategy.length > 0 && data.length > 0) {
      for (const j in data) {
          for (const item of state.commodityStrategy) {
              let n = 0
              if (Number(state.marketDetails[j].symbolId) === Number(item.commodityId)) {
                // const minPriceChange = item.minPriceChange // 最小数量变动单位
                // const minAmountChange = item.minAmountChange // 价格价格变动单位
                // let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
                // let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
                let pricePoint = 0
                let amountPoint = 0
                if (String(item.minPriceChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minPriceChange).indexOf('.') + 1 // 获取小数点的位置
                    pricePoint = String(item.minPriceChange).length - dotNum // 获取小数点后的个数
                }
                if (String(item.minAmountChange).indexOf('.') !== -1) {
                    const dotNum = String(item.minAmountChange).indexOf('.') + 1 // 获取小数点的位置
                    amountPoint = String(item.minAmountChange).length - dotNum // 获取小数点后的个数
                }
                if (pricePoint <= 0) {
                  pricePoint = 0
                }
                if (amountPoint <= 0) {
                  amountPoint = 0
                }
              state.marketDetails[j].numStr = new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$')
              state.marketDetails[j].coinDigitalNum = pricePoint
              state.marketDetails[j].quantityNum = amountPoint
              state.marketDetails[j].quantityStr = new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$')// 数量
              state.marketDetails[j].unitNumeral = item.unitNumeral
              state.marketDetails[j].minPriceChange = item.minPriceChange
              state.marketDetails[j].minAmountChange = item.minAmountChange
              } else {
                  n++
                  if (n === state.commodityStrategy.length) {
                      state.marketDetails[j].numStr = /^(\d+)\.(\d{0,2}).*$/
                      state.marketDetails[j].coinDigitalNum = 2
                      state.marketDetails[j].quantityNum = 2 // 数量
                      state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量
                      state.marketDetails[j].unitNumeral = 1
                      state.marketDetails[j].minPriceChange = 1
                      state.marketDetails[j].minAmountChange = 1
                  }
              }
            }
         
      }
    }
    if(state.commodityStrategy.length == 0){
      for (const j in data) {
        state.marketDetails[j].numStr = /^(\d+)\.(\d{0,2}).*$/
        state.marketDetails[j].coinDigitalNum = 2
        state.marketDetails[j].quantityNum = 2 // 数量
        state.marketDetails[j].quantityStr =/^(\d+)\.(\d{0,2}).*$/ // 数量 
        state.marketDetails[j].unitNumeral = 1
        state.marketDetails[j].minPriceChange = 1
        state.marketDetails[j].minAmountChange = 1
      }
    }
  },
  pricedetail(state, data) {
    // 新数据
    state.pricedetail = data.currentDataArray
    state.pricedetailID = data.contractId
  },
  pricedetail_big(state, data) {
    state.pricedetail_big = data
  },
  clearPriceDetail(state, data) {
    state.pricedetail = []
  },
  clearPriceDetail_big(state, data) {
    state.pricedetail_big.currentDataArray = []
  },
  updateCurrentContractId(state, data) {
    state.currentContractId = 111000017
  },
  updatemarketid(state) {
    state.marketid = 1
  },
  updateOpenCloseTime(state, openTime, closeTime) {
    state.openTime = openTime
    state.closeTime = closeTime
  },
  updatemarketid(state) {
    state.marketid = 1
  },
  buyLst(state, data) {
    state.buyLst = data
  },
  sellLst(state, data) {
    state.sellLst = data
  },
  buyOrderLst(state, data) {
    state.buyOrderLst = data
  },
  sellOrderLst(state, data) {
    state.sellOrderLst = data
  },
  PushPriceDetailResponse(state, data) {
    data.reverse()
    if (data && data.length > 0) {
      const pushData = data[0]
      if (state.pricedetailID==pushData.contractId){
        let newArr = data.concat(state.pricedetail)
        if (newArr.length > 1000) {
          newArr = newArr.slice(0, 1000)
        }
        state.pricedetail = newArr
      }
    }
  },
  PushPriceDetailSetMarketDetails(state, data) {

    if (data && data.length > 0) {
      data.map(pushData => {
        // const pushData = data[data.length - 1]
        state.marketDetails.find((v, i) => {
          if (v.symbolId == pushData.contractId) {
            let key = i
            state.marketDetails[key].amount = pushData.allVolume
            state.marketDetails[key].close = pushData.price
            state.marketDetails[key].high = pushData.highPrice
            state.marketDetails[key].low = pushData.lowPrice
            state.marketDetails[key].quotechange = pushData.qc
            state.marketDetails[key].quote = util.floatSub(pushData.price,pushData.sellPrice)
            state.marketDetails[key].averagePrice = pushData.averagePrice
            state.marketDetails[key].totalAmount = pushData.totalAmount
            state.marketDetails[key].open = pushData.openPrice
            // state.marketDetails[key].turnoverRate = pushData.turnoverRate // 换手率
            state.marketDetails[key].currencyQuantity = pushData.currencyQuantity // 现量
            // state.marketDetails[key].holdQuantity = pushData.holdQuantity // 订货量
            // state.marketDetails[key].warehouseBad = pushData.warehouseBad // 仓差
            state.marketDetails[key].buyCount = pushData.buyCount // 外盘
            state.marketDetails[key].sellCount = pushData.sellCount // 内盘
            return true
          }
        })
      })
    }
  },
  PushHoldResponse(state, data) {
    const pushData = data
    state.marketDetails.find((v, i) => {
      if (v.symbolId == pushData.contractId) {
        let key = i
        // 均价海倍四舍五入；齐鲁小数部分舍去。
        // let averagePrice = Math.floor(Number(pushData.averagePrice))
        // state.marketDetails[key].amount = pushData.allVolume
        // state.marketDetails[key].close = pushData.price
        // state.marketDetails[key].high = pushData.highPrice
        // state.marketDetails[key].low = pushData.lowPrice
        // state.marketDetails[key].quotechange = pushData.qc
        // state.marketDetails[key].quote = Number(util.floatSub(pushData.price,pushData.sellPrice)).toFixed(0)
        // state.marketDetails[key].averagePrice = averagePrice
        // state.marketDetails[key].totalAmount = pushData.totalAmount
        // state.marketDetails[key].open = pushData.openPrice
        state.marketDetails[key].turnoverRate = pushData.turnoverRate // 换手率
        // state.marketDetails[key].currencyQuantity = pushData.currencyQuantity // 现量
        state.marketDetails[key].holdQuantity = pushData.holdQuantity // 订货量
        state.marketDetails[key].warehouseBad = pushData.warehouseBad // 仓差
        // state.marketDetails[key].open == 0 ? state.marketDetails[key].open = pushData.price : state.marketDetails[key].open = state.marketDetails[key].open
        return
      }
    })
  },
  PushPriceDetailResponse_big(state, data) { // 大单筛选
    for (const j in data) {
      if (data.hasOwnProperty(j)) {
        const pushData = data[j]
        const newpricedetail = {}
        newpricedetail.price = pushData.price // 价格
        newpricedetail.volume = pushData.volume // 成交量
        newpricedetail.ioFlag = pushData.ioFlag // 买卖方向 0 买 1 卖
        newpricedetail.quote = util.floatSub(pushData.price,pushData.sellPrice) // 买卖方向 0 买 1 卖
        newpricedetail.occurTime = pushData.occurTime
        newpricedetail.tradeDate = '0'
        newpricedetail.contractId = pushData.contractId // 币种id
        newpricedetail.marketID = '0'
        newpricedetail.averagePrice = '0'
        newpricedetail.buyPrice = '0'
        newpricedetail.sellPrice = '0'
        newpricedetail.tickCount = '0'
        newpricedetail.itemNum = '0'
        newpricedetail.counter = '0'
        // 现量
        newpricedetail.currencyQuantity = pushData.currencyQuantity
        // 订货量
        // newpricedetail.holdQuantity = pushData.holdQuantity
        // 仓差
        // newpricedetail.warehouseBad = pushData.warehouseBad
        // 换手率
        // newpricedetail.turnoverRate = pushData.turnoverRate
        if (state.pricedetail && state.pricedetail.currentDataArray && state.pricedetail.contractId==newpricedetail.contractId) {
          const arrnum = state.pricedetail.currentDataArray.unshift(
            newpricedetail
          )
          if (arrnum >= 30000) {
            state.pricedetail.currentDataArray.pop()
          }
        }
      }
    }
  },
  buyOne(state, data) {
    state.buyOne = data
  },
  sellOne(state, data) {
    state.sellOne = data
  },
  setQueryTradeAuthArr(state, data) {
    state.queryTradeAuthArr = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
